import { formatCurrency, formatDate, convertToPercentage } from "../../../helpers/helpers";
import { GLOBAL_CONSTANTS, DEAL_STATUS_LABEL_MAP } from "../../../constants/constants";
import { Typography, Table } from "antd";

const { Text } = Typography

const DealUnderBus = ({ deal }) => {

  const columns = [
    {
      title: "Deal Id",
      dataIndex: "dealId",
      key: "dealId",
      render: (text) => <Text style={{ fontSize: 14 }}>{text || GLOBAL_CONSTANTS.NA}</Text>,
    },
    {
      title: "Enterprise Name",
      dataIndex: "entName",
      key: "entName",
      render: (text) => <Text style={{ fontSize: 14 }}>{text || GLOBAL_CONSTANTS.NA}</Text>,
    },
    {
      title: "Fund Required",
      dataIndex: "fundRequired",
      key: "fundRequired",
      render: (text) => <Text style={{ fontSize: 14 }}>{formatCurrency(text)}</Text>,
    },
    {
      title: "Approve Fund Amount",
      dataIndex: "approvedFundAmt",
      key: "approvedFundAmt",
      render: (text) => <Text style={{ fontSize: 14 }}>{formatCurrency(text)}</Text>,
    },
    {
      title: "Funded Amount",
      dataIndex: "fundedAmt",
      key: "fundedAmt",
      render: (text) => <Text style={{ fontSize: 14 }}>{formatCurrency(text)}</Text>,
    },
    {
      title: "Interest Rate",
      dataIndex: "annualDiscountRate",
      key: "annualDiscountRate",
      render: (text) => <Text style={{ fontSize: 14 }}>{convertToPercentage(text || 0)}</Text>,
    },
    {
      title: "Deal Created On",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => <Text style={{ fontSize: 14 }}>{formatDate(text)}</Text>,
    },
    {
      title: "Status Name",
      dataIndex: "statusName",
      key: "statusName",
      render: (text, row) => {
        const label =
          DEAL_STATUS_LABEL_MAP[row?.statusId] ||
          (String(text).toLowerCase() === "repaid" ? "Partially Settled" : text);
        return <Text style={{ fontSize: 14 }}>{label || GLOBAL_CONSTANTS.NA}</Text>;
      },
    },
  ]



  return (
    <Table
      columns={columns}
      dataSource={deal}
      bordered
      scroll={{ x: "max-content" }}
      pagination={{ position: ["bottomCenter"] }}
      className="deal-level-funding-table"
      style={{marginTop: 20}}
    />
  );
};


export default DealUnderBus;
